import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
  })
export class AppCookieService {
    private cookieStore = {};

    constructor() {
        this.parseCookies();
    }

    public parseCookies(cookies?: string) {
        const rawCookies = cookies ?? (typeof document !== 'undefined' ? document.cookie : '');
        this.cookieStore = {};
        if (!rawCookies) { return; }
        const cookiesArr = rawCookies.split(';');
        for (const cookie of cookiesArr) {
            const cookieArr = cookie.split('=');
            this.cookieStore[cookieArr[0].trim()] = cookieArr[1];
        }
    }

    get(key: string) {
        this.parseCookies();
        return !!this.cookieStore[key] ? this.cookieStore[key] : null;
    }

    remove(key: string) {
            if (typeof document === 'undefined') return;
      document.cookie = `${key} = ; expires=Thu, 1 jan 1990 12:00:00 UTC; path=/`;
    }

    set(key: string, value: string) {
                if (typeof document === 'undefined') return;
        document.cookie = key + '=' + (value || '');
    }
}
